import StaffRoleUsersPage from "./StaffRoleUsersPage"

export default function MarketingUsersPage() {
  return <StaffRoleUsersPage role="marketing" title="Marketing Users" />
}
